import styled, { css } from 'styled-components';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { Typography } from '../../global/theme';

interface PopoverWrapperProps {
  placement: 'top' | 'bottom' | 'left' | 'right';
  arrowLeft: string;
  arrowTop: string;
}

export const ColorSquaresWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  ${mobile_xl(css`
    flex-wrap: wrap;
  `)}
`;

export const ColorSquareContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ColorSquare = styled.div<{ color: string; isActive: boolean }>`
  width: 64px;
  height: 64px;
  background-color: ${(props) => props.color};
  border-radius: var(--border-radius-4);
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    transform: scale(1.05);
  }
  ${mobile_xl(css`
    width: 54px;
    height: 54px;
  `)}
`;

export const ColorSquareLabel = styled.div`
  font-size: 14px;
  color: #4b5563;
  margin-top: 8px;
  text-align: center;
  line-height: 1.4;
  font-weight: 500;
`;

export const Square = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  p {
    margin: 0;
    ${Typography.body_lg_medium};
    color: var(--text-primary);
  }

  ${mobile_xl(css`
    flex-direction: row;
    gap: 12px;
  `)}
`;

export const PopoverWrapper = styled.div<PopoverWrapperProps>`
  position: fixed;
  z-index: 1000;
  background: white;
  border-radius: var(--border-radius-8);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 0;

  &::before,
  &::after {
    content: '';
    position: absolute;
    pointer-events: none;
    left: ${(props) => props.arrowLeft};
    top: ${(props) => props.arrowTop};
    transform: translateX(-50%);
    overflow: hidden;
    z-index: 9999;
  }

  &::before {
    border: 8px solid transparent;
    z-index: 1;
    ${({ placement }) => {
      switch (placement) {
        case 'bottom':
          return css`
            border-bottom-color: white;
            top: -15px;
            z-index: 9999;
          `;
        case 'top':
          return css`
            border-top-color: white;
            bottom: -15px;
            z-index: 9999;
          `;
        case 'left':
          return css`
            border-left-color: white;
            right: -15px;
            top: 50%;
            z-index: 9999;
            transform: translateY(-50%);
          `;
        case 'right':
          return css`
            border-right-color: white;
            left: -15px;
            top: 50%;
            z-index: 9999;
            transform: translateY(-50%);
          `;
        default:
          return '';
      }
    }}
  }

  &::after {
    border: 8px solid transparent;
    z-index: 2;
    ${({ placement }) => {
      switch (placement) {
        case 'bottom':
          return css`
            border-bottom-color: white;
            top: -15px;
          `;
        case 'top':
          return css`
            border-top-color: white;
            bottom: -15px;
          `;
        case 'left':
          return css`
            border-left-color: white;
            right: -15px;
            top: 50%;
            transform: translateY(-50%);
          `;
        case 'right':
          return css`
            border-right-color: white;
            left: -15px;
            top: 50%;
            transform: translateY(-50%);
          `;
        default:
          return '';
      }
    }}
  }
`;

export const Logo = styled.div`
  width: 64px;
  height: 64px;
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-6);
  padding: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  ${mobile_xl(css`
    width: 54px;
    height: 54px;
    padding: 3px;
  `)}
`;

export const BottomDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${mobile_xl(css`
    align-items: flex-start;
  `)}
`;
